import React from 'react';

// Shared inline error/success/warning banner. Collapses the
// `{msg && <div className="alert alert-...">}` guard that was duplicated —
// with a slightly different className recipe each time — across ~18 files
// onto one consistent branded look (soft shadow, no border, rounded).
const InlineAlert = ({ variant = 'danger', compact = false, rounded = 3, iconRow = false, className = '', children }) => {
  if (!children) return null;
  return (
    <div
      className={`alert alert-${variant} border-0 shadow-sm rounded-${rounded}${compact ? ' small py-2' : ''}${iconRow ? ' d-flex align-items-center mb-4' : ''}${className ? ` ${className}` : ''}`}
      role="alert"
    >
      {children}
    </div>
  );
};

export default InlineAlert;
